import { TextState } from "./types";

export default (): TextState => ({
  wordingsData: {}
});
